import { TaskPositionDetailsComponent } from './component/task-position-details/task-position-details.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { TaskAssignmentDialogComponent } from './component/task-assignment-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { TaskProcessingHintDialogComponent } from './component/task-position-details/task-processing-hint.dialog.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TaskListEntryComponent } from './component/task-list-entry/task-list-entry.component';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  declarations: [
    TaskAssignmentDialogComponent,
    TaskPositionDetailsComponent,
    TaskProcessingHintDialogComponent,
    TaskListEntryComponent
  ],
  exports: [
    TaskPositionDetailsComponent,
    TaskPositionDetailsComponent
  ]
})
export class TaskAssignmentModule { }
